
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import TemplateManagementDrawer from './components/TemplateManagementDrawer.vue';
import { BrandService } from '@/services/brand_service';
import lazyInject from '@/di';
import CopyKaTemplateModal from './components/CopyKaTemplateModal.vue';
import albumLookShops from '@/components/account/albumLookShops.vue';
import moment from 'moment';
import {
  AuthEnum,
} from '@/services/permission.service';

@Component({
  components: {
    TemplateManagementDrawer,
    CopyKaTemplateModal,
    albumLookShops,
  },
})

export default class AlbumTemplateManagement extends Vue {
  AuthEnum = AuthEnum;

  form: any = {
    templateName: '',
    is_default: undefined,
    crated_at_begin: '',
    crated_at_end: '',
  };

  @Ref('templateManagementDrawer')
  templateManagementDrawer!: TemplateManagementDrawer;

  @Ref('copyKaTemplateModal')
  copyKaTemplateModal!: CopyKaTemplateModal;

  @lazyInject(BrandService)
  protected brandService!: BrandService;

  @Ref('albumLookShops')
  albumLookShops!: albumLookShops;

  columns = [
    {
      title: '品牌',
      dataIndex: 'ka_name',
      key: 'ka_name',
      align: 'center',
      scopedSlots: { customRender: 'ka_name' },
    },
    {
      title: '相册模版名称',
      dataIndex: 'template_name',
      key: 'template_name',
      align: 'center',
    },
    {
      title: '适用门店',
      dataIndex: 'shop_num',
      key: 'shop_num',
      align: 'center',
      scopedSlots: { customRender: 'shop_num' },
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      key: 'created_at',
      align: 'center',
    },
    {
      title: '创建人',
      dataIndex: 'username',
      key: 'username',
      align: 'center',
    },
    {
      title: '是否默认模版',
      dataIndex: 'is_default',
      key: 'is_default',
      align: 'center',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      width: 200,
      scopedSlots: { customRender: 'action' },
    },
  ];

  kaId = '';

  kaName: any = '';

  cratedAt: any = [];

  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
    onChange: this.onChange,
    showTotal: (total: any) => `共 ${total} 条`,
  };

  data = [];
  @Watch('$route')
  async watchPagination() {
    const { templateName, pageNum, pageSize, is_default, crated_at_begin, crated_at_end, kaName } = this.$route.query;
    const params: any = {
      page: pageNum || 1,
      pageSize: pageSize || 10,
    };
    if (templateName) {
      params.template_name = templateName;
      this.form.templateName = templateName;
    }
    if (is_default) {
      params.is_default = is_default;
      this.form.is_default = is_default;
    }
    if (crated_at_begin && crated_at_end) {
      params.created_at_begin = crated_at_begin;
      params.created_at_end = crated_at_end;
      this.form.crated_at_begin = moment(crated_at_begin as string).format('YYYY-MM-DD');
      this.form.crated_at_end = moment(crated_at_end as string).format('YYYY-MM-DD');
      this.cratedAt = [crated_at_begin, crated_at_end];
    }
    this.kaName = kaName;
    await this.getTemplateList(this.kaId, params);
  }

  refresh() {
    this.resetQuery();
  }
  search() {
    this.getQueryParams();
  }
  resetQuery() {
    this.form.templateName = '';
    this.form.is_default = undefined;
    this.cratedAt = [];
    this.form.crated_at_begin = null;
    this.form.crated_at_end = null;
    this.pagination.current = 1;
    this.pagination.pageSize = 10;
    this.getQueryParams();
  }

  onChange(page: number) {
    this.pagination.current = page;
    this.getQueryParams();
  }

  onShowSizeChange(current: number, size: number) {
    this.pagination.current = current;
    this.pagination.pageSize = size;
    this.getQueryParams();
  }

  changeTime(val: any) {
    if (!val.length) {
      this.form.crated_at_begin = null;
      this.form.crated_at_end = null;
      return;
    }
    this.cratedAt = val;
    this.$set(
      this.form,
      'crated_at_begin',
      moment(val[0]).format('YYYY-MM-DD'),
    );
    this.$set(
      this.form,
      'crated_at_end',
      moment(val[1]).format('YYYY-MM-DD'),
    );
  }

  getQueryParams() {
    const { current, pageSize } = this.pagination;
    const { templateName, is_default, crated_at_begin, crated_at_end } = this.form;
    const queryParams: any = {
      pageNum: current,
      pageSize,
      kaName: this.kaName,

    };
    if (templateName) {
      queryParams.templateName = templateName;
    }
    if (is_default) {
      queryParams.is_default = is_default;
    }
    if (crated_at_begin) {
      queryParams.crated_at_begin = crated_at_begin;
    }
    if (crated_at_end) {
      queryParams.crated_at_end = crated_at_end;
    }
    queryParams.timestamp = `${Math.round(Date.now() / 1000)}`;
    this.$router.push({
      query: queryParams,
    });
  }
  addTemplate() {
    const data = {
      header: {
        elements: new Array(5).fill(0),
      },
    };
    this.templateManagementDrawer.init(data, 'add');
  }
  async editTemplate(data: any) {
    const res: any = await this.brandService.brandAlbumKaTemplateDetail(data.template_id);
    const { albums, template } = res;
    if (Object.prototype.hasOwnProperty.call(albums, 'header')) {
      albums.header.elements = [...albums.header.elements, ...new Array(5 - albums.header.elements.length).fill(0)];
    } else {
      albums.header.elements = new Array(5).fill(0);
    }
    const allObj = Object.assign({}, albums, template);
    this.templateManagementDrawer.init(allObj, 'edit', data);
  }

  CopyKaTemplate(data: any) {
    this.copyKaTemplateModal.init(data);
  }

  async deleteTemplate(data: any) {
    const porms = {
      template_id: data.template_id,
    };
    this.$confirm({
      title: '提示',
      content: '确认删除该相册模版?',
      okText: '确认',
      okType: 'danger',
      cancelText: '取消',
      onOk: async () => {
        console.log('OK');
        const res = await this.brandService.brandAlbumKaTemplateDelete(porms);
        if (res) {
          this.refresh();
          this.$message.success('删除成功');
        }
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  setdefault(data: any) {
    const porms = {
      template_id: data.template_id,
    };
    this.$confirm({
      title: '提示',
      content: '确认设置该相册模版为默认模版?',
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        console.log('OK');
        const res = await this.brandService.brandAlbumKaTemplateSetDefault(porms);
        if (res) {
          this.refresh();
          this.$message.success('设置成功');
        }
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  async getTemplateList(kaId: string, params: any) {
    const res = await this.brandService.brandAlbumKaTemplateList(kaId, params);
    console.log(res);
    this.data = res.list;
    this.pagination.total = res.total;
  }
  async mounted() {
    const { ka_id } = this.$route.params;
    this.kaId = ka_id;
    this.watchPagination();
  }


  async showAllShops(tempSpuShopIds: any[]) {
    console.log(tempSpuShopIds);
    await this.albumLookShops.open(tempSpuShopIds);
  }

  goLog(val: any) {
    const routeUrl = this.$router.resolve({
      name: 'account.brand_album_log',
      params: {
        templateId: val.template_id,
      },
    });
    window.open(routeUrl.href, '_blank');
  }
}
